<template>

    
  <div class="user-caller">
    
    <user-caller-typeahead  v-show="!isEdit && !caller.id"></user-caller-typeahead>
    
    <cc-user-caller-form></cc-user-caller-form>
    
    <div v-show="caller.id">

      <div style="border-bottom: 1px solid #CCC;">
        <h4 v-if="caller.info" class="alert alert-warning" style="margin-top: 0px;">{{getInfoText}}</h4>
        <div v-else style="padding-top:57px;"></div>
        
         <h2 >
          <i class="fa fa-phone" aria-hidden="true"></i>
          <span v-text="sexText"></span>
          <span>{{UserConf.getPertitel(caller.idPertitel)}}</span>
           {{caller.firstName}} {{caller.lastName}} 
           <small v-show="caller.customerNumber" > (KdNr: {{caller.customerNumber}})</small>
           <small>{{caller.street}}</small>
           <small>{{caller.streetNumber}},</small>
           <small>{{caller.zipCode}}</small>
           <small>{{caller.city}}</small>
        
          <div class="pull-right">
           <button v-show="isCallerCompanySameAsClientCompany" 
            type="button" class="btn btn-default" 
            v-on:click="onClickIsClientCompany">
            <i class="fa fa-user" title="Mitarbeiter"></i>
          </button>

          <button 
            type="button" class="btn btn-default" 
            v-on:click="onClickEdit">
            <i class="fa fa-pencil" title="Anrufer bearbeiten"></i>
          </button>

          <button 
            type="button" class="btn btn-default" 
            v-on:click="onClickClone">
            <i class="fa fa-clone" title="Anrufer kopieren"></i> 
          </button>

          <button 
            type="button" class="btn btn-default" 
            v-on:click="onClickCancel">
            <i class="fa fa-eye-slash" title="neu suchen"></i>
          </button>        
         </div>
         
        </h2>
      </div> 

      <div></div>
      <p v-show="caller.company.name" style="">
          <i class="fa fa-industry" aria-hidden="true"></i>
          <strong>Fa: {{caller.company.name}}</strong>
           - <small>{{caller.company.street}}</small>
           <small>{{caller.company.streetNumber}},</small>
           <small>{{caller.company.zipCode}}</small>
           <small>{{caller.company.city}}</small>
      </p>

      <div class="cc-kombox-items">


        <cc-kombox-usercaller
          class="cc-kombox-item"
          v-for="kombox in caller.komboxes"
          :kombox="kombox"
          :key="kombox.id"
          @remove="onRemoveKombox"
          @update="onSetKombox"
          @add-shipping="onKomboxAddShipping"
          @remove-shipping="onKomboxRemoveShipping">
        </cc-kombox-usercaller>


        
        <div v-show="!caller.komboxes.length" class="alert alert-warning" role="alert">Keine Kontaktdaten hinterlegt</div>
      
      </div>
      
       <cc-kombox-usercaller 
          v-if="caller.id > 0"
          class="cc-kombox-item" 
          :idCompany="0"
          :idUser="caller.id"
          @insert="onAddKombox">
       </cc-kombox-usercaller>

       <cc-kombox-usercallercolleague
          v-if="!isCallerCompanySameAsClientCompany"
          class="cc-kombox-item"
          v-for="kombox in caller.company.komboxes"
          :kombox="kombox"
          @add-shipping="onKomboxAddShipping"
          @remove-shipping="onKomboxRemoveShipping">
        </cc-kombox-usercallercolleague>

    </div>            
  </div>            
                   
    
</template>



<script>

import UserCallerTypeahead from './UserCallerTypeahead.vue'
import KomboxUserCaller from './KomboxUserCaller.vue'
import KomboxUserCallerColleague from './KomboxUserCallerColleague.vue'
import KomboxForm from './KomboxForm.vue'
import UserCallerForm from './UserCallerForm.vue'
import bus from './common/bus'
import * as UserConf from './common/user.conf'

export default {
    
  components: {
    'user-caller-typeahead': UserCallerTypeahead,
    'cc-kombox-usercaller': KomboxUserCaller,
    'cc-kombox-usercallercolleague': KomboxUserCallerColleague,
    'cc-user-caller-form': UserCallerForm,

  },
  
  data () {
    return {
      UserConf: UserConf,
      isUserClient: false,
      isEdit:false,
      caller: {
        company:{
          id: 0,
          idCompanyContact: '',
          name: '',
          komboxes:[],

        },
        komboxes:[],
      },
      shippingIds: bus.call.idsKomboxUserCaller,
    }
  },
  
  created: function () {
    bus.registerOnIdUserCaller(this.onIdUserCaller);
    bus.registerOnNewUserCaller(this.onNewUserCaller);

    //bus.registerOnIdCompanyClient(this.reset); // Rest if new Company Client
  },
  
  computed: {
    isCallerCompanySameAsClientCompany: function () {
      return this.caller.idCompany == bus.call.idCompanyClient ? true : false;
    },

    sexText: function () {
      if(typeof this.caller.idSex == 'string'){
        return this.caller.idSex == '1' ? 'Herr' : this.caller.idSex == '2' ? 'Frau' : '';
      }
    },

    getInfoText: function () {
      return "VIP: " + this.caller.info;
    },

    
  },
  
  methods: {

    onIdUserCaller: function (idUserCaller, event, call) {
      this.reset();
      // Ist der Anrufer auch ein Mitarbeiter 
      this.isUserClient = (call.idUserClient == idUserCaller) ? true : false;
      if(idUserCaller > 0){
        this.loadUserCaller(idUserCaller);
      }
    },

    onNewUserCaller: function () {
      this.isEdit = true;
    },
    
    
    onClickAddKombox: function () {
      this.caller.komboxes.push({
            type: 0,
            acl: 1,
            content: '',
            description: '',
          });
    },

  
    onRemoveKombox: function (kombox) {
      const indexOf = this.caller.komboxes.indexOf(kombox);
      if(indexOf != -1){
        this.caller.komboxes.splice(indexOf, 1);
      }
    },
    
    onSetKombox: function (kombox) {
      // Note: kombox is a reference or a clone
      const indexOf = _.findIndex(this.caller.komboxes, ['id', kombox.id]);
      if(indexOf != -1){
        this.$set(this.caller.komboxes, indexOf, kombox);
      }
    },
    
    onAddKombox: function (kombox) {
        this.caller.komboxes.push(kombox);
    },
    
    onKomboxAddShipping: function (kombox) {
      if(this.shippingIds.indexOf(kombox.id) == -1){
        this.shippingIds.push(kombox.id);
      }
    },

    onKomboxRemoveShipping: function (kombox) {
      this.shippingIds.splice(this.shippingIds.indexOf(kombox.id), 1);
    },
    
    
    


    onClickIsClientCompany: function () {
      bus.emitIdUserClient(this.caller.id);
    },
    
    onClickEdit: function () {
      bus.emitEditUserCaller(this.caller);
      this.reset();
      this.isEdit = true;
    },
    
    onClickClone: function () {
      bus.emitCloneUserCaller(this.caller);
      this.reset();
      this.isEdit = true;
    },
    
    onClickCancel: function () {
      this.reset();
      bus.emitIdUserCaller(0);
      bus.emitCompanyCaller(this.caller.company); // entspricht {}
    },
      
    reset: function () {
      this.isUserClient = false;
      this.isEdit = false;
      this.caller = {
        company:{},
        komboxes:[],
      };
      
      this.caller.company.id = 0;
      this.caller.company.idCompanyContact = '';
      this.caller.company.name = '';
      this.caller.company.komboxes = [];

      this.shippingIds.splice(0 , this.shippingIds.length); // bus refrenz on this.shippingIds
    },
    

    
    loadUserCaller: function (idUserCaller) {
      this.$http.get(bus.config.path + '/user/caller/' + idUserCaller).then((response) => {
        
        // Hier wird der Versand nicht ausgewählt...
        response.data.komboxes.forEach(function(kombox, index, array) {
          kombox.shippingActiv = 1;
        });
        
        this.caller = response.data;
        bus.emitUserCaller(this.caller);
        bus.emitCompanyCaller(this.caller.company);
        this.isEdit = false;
        

      }, (response) => {
      // error callback
      });
    },

    
  }
  
}
</script>



<style scoped>
.row{
    margin: 0;
  }
  
.btn{
    padding: 4px 10px;
}
  
  .fa{
    color: #337ab7;
  }
  .fa-ban{
    color: #fff;
  }
  .fa-industry{
    padding-left: 15px;
    padding-top: 10px;
  }
  
  .user-caller{
    overflow: auto;
  }
  
  button{
  }
  
  
  .cc-kombox-items{
    margin-top: 20px;
  }
  
.cc-kombox-item{
    border-top: 1px solid lightgrey;
    padding-top: 6px;
    padding-bottom: 6px;
  
}  
  
.cc-kombox-item:hover{
  background-color: #fcf8e3;
}

.xxcc-kombox-list{
    overflow: auto;
}
  
</style>



// WEBPACK FOOTER //
// UserCaller.vue?ab7f060a